import React from "react";
import { CheckCircle } from "lucide-react";

export function TipsCard() {
  return (
    <div className="border border-slate-200 rounded-xl p-3 bg-white">
      <div className="font-bold text-slate-900 mb-2 text-[15px]">Tips</div>
      <div className="text-slate-500 mb-4 leading-snug text-[13px]">
        Here are some tips to manage your account.
      </div>
      <ul className="space-y-3 text-[13px] text-slate-500 leading-snug">
        <li className="flex items-start gap-2">
          <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
          <span className="font-normal">Keep your email and password up to date.</span>
        </li>
        <li className="flex items-start gap-2">
          <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
          <span className="font-normal">We'll email you important updates and receipts.</span>
        </li>
        <li className="flex items-start gap-2">
          <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
          <span className="font-normal">Your account settings help personalize your experience.</span>
        </li>
      </ul>
    </div>
  );
}
